import clsx from 'clsx';
import { useContext } from 'react';

// Components
import { CompoundTableContext } from '@/components/base/Table/CompoundTable';

const TableBodyPlaceholder = ({ nbRows = 5 }: { nbRows?: number }) => {
    const { table, columnIdHover } = useContext(CompoundTableContext);

    const nbColumns = table.getVisibleLeafColumns().length;
    return (
        <tbody data-testid="table-body-placeholder">
            {[...new Array(nbRows)].map((_, rowIndex) => {
                return (
                    <tr
                        key={rowIndex}
                        className={clsx({ 'sticky top-14 z-2 shadow-icoXS': rowIndex === 0 })}>
                        {table.getVisibleLeafColumns().map((column, cellIndex) => {
                            const isColumnHovered = columnIdHover === cellIndex;
                            const isGroupAvatar = rowIndex === 0 && cellIndex === 0;
                            const isSocialProfileAvatar = rowIndex !== 0 && cellIndex === 0;
                            return (
                                <td
                                    key={column.id}
                                    className={clsx(
                                        'relative h-14 border-icoGray-300 bg-white dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite',
                                        {
                                            'border-r': cellIndex < nbColumns - 1,
                                            'border-b': rowIndex < nbRows - 1,
                                            'sticky left-0 z-1': column.columnDef.meta?.isSticky
                                        }
                                    )}>
                                    {isColumnHovered ? (
                                        <div className="absolute inset-0 bg-icoBlue bg-opacity-[0.02]" />
                                    ) : null}
                                    <div className="flex items-center justify-center">
                                        <div
                                            className={clsx(
                                                'animate-pulse bg-icoGray-300 dark:bg-icoDarkMode-deepBlack',
                                                {
                                                    'h-3.5 w-17 rounded-sm':
                                                        !isGroupAvatar && !isSocialProfileAvatar,
                                                    'h-10 w-10 rounded-md': isGroupAvatar,
                                                    'h-10 w-10 rounded-full': isSocialProfileAvatar
                                                }
                                            )}
                                        />
                                    </div>
                                </td>
                            );
                        })}
                    </tr>
                );
            })}
        </tbody>
    );
};

export default TableBodyPlaceholder;
